// extracted by mini-css-extract-plugin
module.exports = {"unavailable":"Gas_unavailable__2su-p","wrapper":"Gas_wrapper__1eXBk","panel":"Gas_panel__24t0J"};